export const Fashionapi = [
  {
    id: 1,
    image:
      "https://www.libas.in/cdn/shop/files/mobile-libas-art-main-hompage-banner_1024x1024.jpg?v=1699602234",
  },
  {
    id: 2,
    image:
      "https://7f4e08ee.rocketcdn.me/wp-content/uploads/2019/10/Types-of-salwar-suits-women-front-slit.jpg",
  },
  {
    id: 3,
    image:
      "https://t3.ftcdn.net/jpg/05/66/32/00/360_F_566320035_AFE3zZnhteQAqHECnIpZBqQ2ODDWuRBW.jpg",
  },
  {
    id: 4,
    image:
      "https://thumbs.dreamstime.com/b/fashion-model-holding-gold-jewelry-hands-woman-golden-beauty-beautiful-girl-makeup-luxury-jewellery-89332492.jpg",
  },
];
